// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPhacoMachineDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.5 24C8.32843 24 9 23.3284 9 22.5 9 21.6716 8.32843 21 7.5 21 6.67157 21 6 21.6716 6 22.5 6 23.3284 6.67157 24 7.5 24ZM16.5 24C17.3284 24 18 23.3284 18 22.5 18 21.6716 17.3284 21 16.5 21 15.6716 21 15 21.6716 15 22.5 15 23.3284 15.6716 24 16.5 24Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0V8H11V9H7V20.05C7.16155 20.0172 7.32877 20 7.5 20C8.0628 20 8.58217 20.186 9 20.4998V11H15V20.4998C15.4178 20.186 15.9372 20 16.5 20C16.6712 20 16.8384 20.0172 17 20.05V9H13V8H18V0H6ZM16 2H8V6H16V2Z" class="svg-bg"/>
  <path d="M14.05 23C14.0172 22.8384 14 22.6712 14 22.5 14 21.9372 14.186 21.4178 14.4998 21H9.50018C9.81403 21.4178 10 21.9372 10 22.5 10 22.6712 9.98278 22.8384 9.94999 23H14.05ZM10 12H14V14H10V12Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H24V10H17V12H22V27C21.2316 27 20.5308 27.2889 20 27.7639V14H12V27.7639C11.4692 27.2889 10.7684 27 10 27V12H15V10H8V0ZM10 2H22V8H10V2Z" class="svg-bg"/>
  <path d="M14 16H18V18H14V16ZM10 32C11.1046 32 12 31.1046 12 30 12 28.8954 11.1046 28 10 28 8.89543 28 8 28.8954 8 30 8 31.1046 8.89543 32 10 32ZM24 30C24 31.1046 23.1046 32 22 32 20.8954 32 20 31.1046 20 30 20 28.8954 20.8954 28 22 28 23.1046 28 24 28.8954 24 30ZM12.8293 29H19.1707C19.0602 29.3128 19 29.6494 19 30 19 30.3506 19.0602 30.6872 19.1707 31H12.8293C12.9398 30.6872 13 30.3506 13 30 13 29.6494 12.9398 29.3128 12.8293 29Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPhacoMachineDefault is a generated icon component.
 */
let IconMedPhacoMachineDefault = IconMedPhacoMachineDefault_1 = class IconMedPhacoMachineDefault extends IconBaseElement {
    render() {
        return html `${IconMedPhacoMachineDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPhacoMachineDefault.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedPhacoMachineDefault = IconMedPhacoMachineDefault_1 = __decorate([
    customElement('zui-icon-med-phaco-machine-default')
], IconMedPhacoMachineDefault);
export { IconMedPhacoMachineDefault };
